<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid d-flex justify-content-between align-items-center">
      <button
        href
        class="navbar-toggler navbar-toggler-right mr-3 p-0"
        type="button"
        data-toggle="collapse"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
    </div>
    <div class="form-group mt-3" v-if="showClients()">
      <select class="form-control" name="client" v-model="client_id" @change="changeClientValue()">
        <option v-for="(client, index) in clients" :key="index" :value="client.id">{{ client.name }}</option>
      </select>
    </div>
  </nav>
</template>

<script>
import AuthController from "../../controllers/AuthController.js";
import ClientController from "../../controllers/ClientController";
import Roles from "../../models/Roles";
export default {
  created() {
  },

  props: {
    profileRouter: String
  },

  data() {
    return {
      clients: [],
      client_id: null,
      imageUrl: null,
      authController: new AuthController(this.$resource, this.$router),
      clientController: new ClientController(this.$resource),
      profile: localStorage.getItem("profile")
    };
  },

  methods: {
    async getLogoClient() {
      let response = await this.clientController.getLogoClient();
      this.imageUrl = response;
    },
    showClients() {
      if (
        this.clients.length > 1 &&
        localStorage.getItem("profile") == Roles.Admin
      )
        return true;
      else return false;
    },
    changeClientValue() {
      try {
        this.authController.reloadToken(this.client_id).then(res => {
          window.location.reload();
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getClientsByUser() {
      let response = await this.clientController.getClientsByUser();
      if (response.length > 1) {
        this.clients = response;
      }
      this.client_id = localStorage.getItem("client_id");
    },
    logout() {
      this.authController.logout();
    }
  },

  beforeMount() {
    this.getLogoClient();
    // this.getClientsByUser();
  }
};
</script>

<style lang="scss">
.vdatetime-time-picker__list::-webkit-scrollbar {
  width: 8px;
}
.container-fluid.d-flex>*{
	flex: none !important
}
.modal-backdrop {
	z-index: 999 !important;
}

nav {
  @media(max-width: 991px) {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100vw;
    max-width: 100%;   
  }
  @media (min-width: 992px) {
     display: none !important;
  }
}
</style>
